import React from 'react'

import { createBrowserRouter } from 'react-router-dom'

import { ChangeEmailRoute } from './ChangeEmailRoute'
import { ChangePasswordAndroidRoute } from './ChangePasswordAndroidRoute'
import { ChangePasswordIOSRoute } from './ChangePasswordIOSRoute'
import { ChangePasswordRoute } from './ChangePasswordRoute'
import { ForgotPasswordRoute } from './ForgotPasswordRoute'
import { ResetPasswordRoute } from './ResetPasswordRoute'
import { LoginSuccessRoute } from './LoginSuccessRoute'
import { SentryReactTestRoute } from './SentryReactTestRoute'
import { SignInPartnerRoute } from './SignInPartnerRoute'
import { SignInIOSRoute } from './SignInIOSRoute'
import { SignInRoute } from './SignInRoute'
import { SignInMobileRoute } from './SignInMobileRoute'
import { CareAuthenticationRequestRoute } from './CareAuthenticationRequestRoute'
import { ChangePhoneNumberRoute } from './ChangePhoneNumberRoute'
import { PasskeyManagementAndroidRoute } from './PasskeyManagementAndroidRoute'
import { PasskeyManagementIOSRoute } from './PasskeyManagementIOSRoute'
import { PasskeyManagementRoute } from './PasskeyManagementRoute'
import { ProfileAndroidRoute } from './ProfileAndroidRoute'
import { ProfileIOSRoute } from './ProfileIOSRoute'
import { ProfileRoute } from './ProfileRoute'
import { SignInAndroidRoute } from './SignInAndroidRoute'
import { TrustedDeviceManagementAndroidRoute } from './TrustedDeviceManagementAndroidRoute'
import { TrustedDeviceManagementIOSRoute } from './TrustedDeviceManagementIOSRoute'
import { TrustedDeviceManagementRoute } from './TrustedDeviceManagementRoute'
import { TwoStepVerificationPushResponseRoute } from './TwoStepVerificationPushResponseRoute'
import { TwoStepVerificationTesterRoute } from './TwoStepVerificationTesterRoute'

export const router = createBrowserRouter([
  {
    path: '/signin',
    element: <SignInRoute />,
  },
  {
    path: '/signin/mobile',
    element: <SignInMobileRoute />,
  },
  {
    path: '/signin/ios',
    element: <SignInIOSRoute />,
  },
  {
    path: '/signin/android',
    element: <SignInAndroidRoute />,
  },
  {
    path: '/forgot_password',
    element: <ForgotPasswordRoute />,
  },
  {
    path: '/reset_password',
    element: <ResetPasswordRoute />,
  },
  {
    path: '/care_authentication_request',
    element: <CareAuthenticationRequestRoute />,
  },
  {
    path: '/two_step_verification/push/response',
    element: <TwoStepVerificationPushResponseRoute />,
  },
  {
    path: '/two_step_verification_tester',
    element: <TwoStepVerificationTesterRoute />,
  },
  {
    path: '/signin_partner',
    element: <SignInPartnerRoute />,
  },
  {
    path: '/change_email',
    element: <ChangeEmailRoute />,
  },
  {
    path: '/profile/change_password',
    element: <ChangePasswordRoute />,
  },
  {
    path: '/profile/change_password/ios',
    element: <ChangePasswordIOSRoute />,
  },
  {
    path: '/profile/change_password/android',
    element: <ChangePasswordAndroidRoute />,
  },
  {
    path: '/profile/passkey_management',
    element: <PasskeyManagementRoute />,
  },
  {
    path: '/profile/passkey_management/ios',
    element: <PasskeyManagementIOSRoute />,
  },
  {
    path: '/profile/passkey_management/android',
    element: <PasskeyManagementAndroidRoute />,
  },
  {
    path: '/profile/trusted_device_management',
    element: <TrustedDeviceManagementRoute />,
  },
  {
    path: '/profile/trusted_device_management/ios',
    element: <TrustedDeviceManagementIOSRoute />,
  },
  {
    path: '/profile/trusted_device_management/android',
    element: <TrustedDeviceManagementAndroidRoute />,
  },
  {
    path: '/admin/debug/sentry_react_test',
    element: <SentryReactTestRoute />,
  },
  {
    path: '/login_success',
    element: <LoginSuccessRoute />,
  },
  {
    path: '/profile',
    element: <ProfileRoute />,
  },
  {
    path: '/profile/ios',
    element: <ProfileIOSRoute />,
  },
  {
    path: '/profile/android',
    element: <ProfileAndroidRoute />,
  },
  {
    path: '/profile/change_phone_number',
    element: <ChangePhoneNumberRoute />,
  },
])
